import { z } from 'zod';

export const SubmitFeedbackSchema = z.object({
  type: z.enum(['bug', 'feedback', 'question']),
  text: z.string(),
  metadata: z.unknown().optional(),
  screen_name: z.string().optional(),
  device_info: z.unknown().optional(),
  email: z.string().optional(),
  attachment: z
    .object({
      name: z.string(),
      type: z.string(),
      image: z.string(),
    })
    .optional(),
});
